if (PJQ.app.module === PJQ.constants.modules.PJQADDRESSBOOK) {
	PJQ.app.addOldRoutes([
		{
			route: '',
			name: 'default',
			callback: function () {
				window.ValidateEmail = function (email) {
					return PJQ.helpers.validators.validateEmail(email);
				};

				initAddressBook($('#pjq-main'));
			}
		}
	]);
	PJQ.app.attachReadyEvent(function () {
		initAddressBook($('#pjq-main'));
	});
}
else if (PJQ.app.module === PJQ.constants.modules.APP) {
	PJQ.modules.pjqAddressBook = {
		routes: [
			{
				route: 'contacts',
				name: 'contacts',
				callback: function () {
					PJQ.app.initNavigator({
						activeItem: "contacts"
					});
				}
			}
		]
	};
	PJQ.app.addRoutes(PJQ.modules.pjqAddressBook.routes);
}